<template>
    <div class="border bg-blue-100 dark:bg-gray-700 rounded p-4 mt-3">
        <div class="mb-4">Items</div>
        <draggable
            v-model="items"
            ghost-class="bg-gray-500"
            handle=".handle">

            <div v-for="(item, index) in items" class="flex" :key="`atfAccordionListItem-${item.id || item.uuid}`">
                <div class="ml-4 handle mt-2 float-left text-gray-400" title="Drag to reorder items">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                    </svg>
                </div>
                <div
                    @click="handleDelete(index)"
                    class="ml-2 mt-2 cursor-pointer"
                >
                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                </div>

               <div class="float-right mb-8 w-full ml-3">
                    <div
                        class="border bg-white dark:bg-gray-700 rounded-lg p-4 shadow-sm max-w-2xl w-[49%] float-left mt-3"
                    >
                        <rocket-link
                            :language="language"
                            v-model="item.link"
                            class="mt-5"
                            label="Link"
                            :resettable="true"
                            :error="errors[`atf_accordion_list.items.${index}.link`] ? errors[`atf_accordion_list.items.${index}.link`][0] : null"
                        />
                    </div>

                    <div
                        class="border bg-white dark:bg-gray-700 rounded-lg p-4 shadow-sm max-w-2xl w-[49%] float-right mt-3"
                    >
                        <input-text
                            name="description"
                            label="* Description"
                            v-model="item.description"
                            :maxlength="255"
                            :error="errors[`atf_accordion_list.items.${index}.description`] ? errors[`atf_accordion_list.items.${index}.description`][0] : null"
                        />
                    </div>
                </div>
            </div>
        </draggable>
        <button slot="footer"
            v-if="items.length < maxItems"
            class="mt-6 text-indigo-600 dark:text-indigo-300 hover:text-indigo-900 dark:hover:text-indigo-200"
            type="button"
            @click="addItem"
        >
            + Add item
        </button>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import siteLanguage from '../config/siteLanguage';
import {v4 as uuidv4} from "uuid"

export default {
    components: { draggable },
    name: "AtfAccordionListItems",
    props: {
        value: [Object, Array],
        errors: {
            type: [Array, Object],
            required: true,
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data() {
        return {
            maxItems: 10,
            items: this.value || [],
        };
    },
    updated() {
        this.$emit("input", this.items);
    },
    methods: {
        defaultData() {
            return {
                description: "",
                link: {},
                uuid: uuidv4(),
            }
        },
        addItem(e) {
            e.preventDefault();
            this.items.push(this.defaultData());
        },
        handleDelete: function (indexOfItemToDelete) {
            if (confirm('Are you sure you want to remove this item?')) {
                this.items.splice(indexOfItemToDelete, 1);
            }
        },
    }
};
</script>
